import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { TranslateDirective } from '@language/translate.directive';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'flw-frontend-modal',
  templateUrl: './frontend-modal.component.html',
  imports: [NgIf, FontAwesomeModule, TranslateDirective],
  standalone: true,
})
export class FrontendModalComponent {
  @Input() message = '';
  @Input() title = '';

  constructor(public modal: NgbActiveModal) {}

  clear(): void {
    this.modal.dismiss();
  }

  confirm(): void {
    this.modal.close(true);
  }

  protected readonly faTimes = faTimes;
}
